// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CustomerGroupCodeService = {};

CustomerGroupCodeService.getCustomerGroupCodeList = function (userInput) {
  return lossClient({
    url: "/CustomerGroup/items?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default CustomerGroupCodeService;
